module.exports = __webpack_public_path__ + "static/lato-latin-700italic.4ad27904.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-lato/files/lato-latin-700italic.woff
// module id = ./node_modules/typeface-lato/files/lato-latin-700italic.woff
// module chunks = 17241999800008180000